import { useFetch } from '@/utils/useService';

export default {
  getDetails(id) {
    return useFetch('/media/' + id, { method: 'GET' });
  },

  getDetailsFromChannel(channelId, mediaId) {
    return useFetch('/media/' + mediaId + `?channelId=${channelId}`, {
      method: 'GET',
    });
  },
  getChapters(mediaId, channelId) {
    const query = channelId ? `?channelId=${channelId}` : '';
    return useFetch(`/media/${mediaId}/chapters${query}`, { method: 'GET' });
  },
  getChapterById(mediaId, chapterId) {
    return useFetch(`/media/${mediaId}/chapters/${chapterId}`, {
      method: 'GET',
    });
  },
  getAttachments(mediaId) {
    return useFetch(`/media/${mediaId}/attachments`, { method: 'GET' });
  },
};
